<template>
	<v-dialog :value="dialog" max-width="680px" persistent>
		<v-card>
			<v-toolbar flat dense color="info" dark>
				<v-toolbar-title class="subheading">{{ title }}</v-toolbar-title>
				<v-spacer></v-spacer>
			</v-toolbar>
			<v-card-text>
				<residential-address-form
					ref="form"
					v-model="form"
					:excluded-effective-dates="excludedEffectiveDates"
					is-edit
				></residential-address-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn flat :disabled="isSaving" @click="$emit('cancel')">Cancel</v-btn>
				<v-btn color="primary" flat :loading="isSaving" @click="save">Save</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	import moment from 'moment';
	import ResidentialAddressForm from '@/components/employee/forms/ResidentialAddressForm';

	const emptyAddress = () => ({
		id: null,
		effectiveDate: moment().format('YYYY-MM-DD'),
		addressLine1: '',
		addressLine2: '',
		suburb: '',
		state: '',
		postcode: '',
		country: 'Australia'
	});

	export default {
		components: { ResidentialAddressForm },
		props: {
			dialog: {
				type: Boolean,
				required: true
			},
			address: {
				type: Object,
				default: null
			},
			excludedEffectiveDates: {
				type: Array,
				default: () => []
			},
			isSaving: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				form: this.address ? { ...this.address, country: this.address.country || 'Australia' } : emptyAddress()
			};
		},
		computed: {
			title() {
				return this.address ? 'Edit Residential Address' : 'Add Residential Address';
			}
		},
		methods: {
			save() {
				if (this.$refs.form.$_validateForm()) {
					this.$emit('save', { ...this.form });
				}
			}
		}
	};
</script>
